import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddHomework from "../../../containers/admin/homework/models/add-homework";
import SearchBar from "../../../containers/admin/homework/searchbar";
import HomeworkTable from "../../../containers/admin/homework/table";
import { getAllHomeworksRequest } from "../../../modules/admin-modules/homework/Actions";

const Homeworks = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getAllHomeworksRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <AddHomework
        key={`hw-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
      <HomeworkTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
    </Layout>
  );
};

export default Homeworks;
